/**
 * Hotel guest custom validations
 * Extracted from guestConfig for readability and reuse
 */

/**
 * Returns custom validation rules for hotel guest selection
 * @param {Object} HOTEL_PASSENGER_TYPES - Slugs for guest types
 * @returns {Array} List of validation rule objects
 */
export const createHotelGuestCustomValidations = (HOTEL_PASSENGER_TYPES) => [
  {
    rule: (values) => {
      const adults = values[HOTEL_PASSENGER_TYPES.ADULT] || 0;
      return adults >= 1;
    },
    messageKey: "hotel.passengerValidationMinAdult",
    message: "En az bir yetişkin misafir seçilmesi gerekmektedir",
    path: HOTEL_PASSENGER_TYPES.ADULT,
  },
  {
    rule: (values) => {
      const children = values[HOTEL_PASSENGER_TYPES.CHILD] || 0;
      if (children > 0) {
        const adults = (values[HOTEL_PASSENGER_TYPES.ADULT] || 0)
        return adults >= 1;
      }
      return true;
    },
    messageKey: "hotel.passengerValidationChildNeedsAdult",
    message: "Çocuk misafirler için en az bir yetişkin gereklidir",
    path: HOTEL_PASSENGER_TYPES.CHILD,
  },
];


